import { typography } from "./typography";
import { colors } from "./colors";
export interface ElementProps {
    form: {
        input: {
            height: string;
            borderRadius: string;
            fontSizeText: string;
            fontSizeLabel: string;
            fontSizeError: string;
            padding: string;
        };
        checkbox: {
            fontSize: string;
            containerBorderRadius: string;
            colorDisabled: string;
            colorText: string;
            colorError: string;
            colorCheckmark: string;
            colorContainerBorder: string;
            colorContainerBorderOnHover: string;
            colorContainerBackgrounChecked: string;
            colorContainerBackgroundOnHover: string;
            colorContainerBackgroundOnFocus: string;
        };
    };
    button: {
        height: string;
        borderRadius: string;
        fontSize: string;
        minWidth: string;
        padding: string;
        withIcon: {
            minWidth: string;
            padding: string;
        };
    };
}

export const elements: ElementProps = {
    form: {
        // TODO: Source below values from theme defauls where possible
        input: {
            height: "30px",
            borderRadius: "2px",
            fontSizeText: "14px",
            fontSizeLabel: "14px",
            fontSizeError: "10px",
            padding: "0 12px"
        },
        checkbox: {
            fontSize: typography.sizes[16],
            containerBorderRadius: "2px",
            colorDisabled: colors["white.25"],
            colorText: colors["white.100"],
            colorError: colors.error.strong,
            colorCheckmark: colors["black.100"],
            colorContainerBorder: colors["white.50"],
            colorContainerBorderOnHover: colors["white.50"],
            colorContainerBackgrounChecked: colors["white.100"],
            colorContainerBackgroundOnHover: colors["white.10"],
            colorContainerBackgroundOnFocus: colors["white.25"]
        }
    },
    button: {
        height: "30px",
        borderRadius: "2px",
        fontSize: "14px",
        minWidth: "64px",
        padding: "0 12px 0",
        withIcon: {
            minWidth: "78px",
            padding: "0 12px 0"
        }
    }
};
